import { useAlternativeUser } from "@/contexts/AlternativeUserContext";
import { useTelegramChatId } from "@/hooks/use-chat-id";
import { useTelegramActivation } from "@/hooks/useTelegramActivation";
import { saleActivationLocation } from "@/utils/saleNavigation";
import { Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import AuthPage from "@/pages/AuthPage";

export default function GlobalState({ children, basePath = "" }: { children: React.ReactNode; basePath?: string }) {
  const { setUser } = useAlternativeUser();
  const navigate = useNavigate();
  const location = useLocation();
  const chatId = useTelegramChatId();
  const activation = useTelegramActivation(chatId, (response) => {
    const sale = response.sale || response.task;
    if (sale) {
      setUser(null);
      sessionStorage.setItem("active_mini_app", "sale-support");
      const destination = saleActivationLocation(sale);
      navigate({ pathname: destination.pathname, search: destination.search }, { replace: true, state: destination.state });
    } else {
      sessionStorage.setItem("active_mini_app", "primary");
      setUser(response.eventTemplateAlternativeUser || null);
      if (location.pathname === `${basePath}/auth`) navigate(basePath || "/", { replace: true });
    }
  });

  if (activation.phase !== "authenticated") {
    return <AuthPage phase={activation.phase} error={activation.message} errorActionKey={activation.actionKey} saleUnavailable={activation.saleUnavailable}
      onActivate={activation.activate} onRetry={activation.retry} />;
  }

  return <Box id="global-state" sx={{ minHeight: "100vh", position: "relative" }}>{children}</Box>;
}
